import { Button, Grid } from '@mui/material'
import React from 'react'
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { Stack } from '@mui/system';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { PostOnlinePayment } from 'API/DS_Wallet/api';

const AddMoneyTab = (props) => {
    const PaymentMode = props.payment_option;
    const [Amount, setAmount] = React.useState(null)
    const [DepositData, setDepositData] = useState({})

    const [OpenAlert, setOpenAlert] = useState(false)
    const [AlertMessage, setAlertMessage] = useState("")
    const [AlertType, setAlertType] = useState("success")
    const [IsLoading, setIsLoading] = useState(false)

    const handleAlertOpen = () => {
        setOpenAlert(true)
    }

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    const handleOpenLoader=()=>{
        setIsLoading(true)
    }

    const handleCloseLoader=()=>{
        setIsLoading(false)
    }


    const Nav = useNavigate()

    console.log("Props", props);

    const handleAmountValueChange = (event) => {
        if (/^\d*\.?\d{0,2}$/.test(event.target.value) && parseFloat(event.target.value) <= 100000000 || event.target.value==="") {

            setAmount(event.target.value)
        }
    }


    const handleAmountChange = (name, value) => {
        console.log(DepositData);

        if (name == 'sign_on') {
            if (parseInt(value) <= parseInt(DepositData['total_amount'])) {

                setDepositData({ ...DepositData, [name]: parseInt(value), ['hardware']: parseInt(eval(DepositData['total_amount'] - value)) });
            }
            else {
                if (value === '') {
                    setDepositData({ ...DepositData, [name]: 0, ['hardware']: parseInt(DepositData['total_amount']) })
                }
                else {
                    setAlertMessage("Amount should not be greater than total amount")
                    setAlertType("error")
                    handleAlertOpen()
                }

            }
        }
        else if (name == 'hardware') {
            if (parseInt(value) <= parseInt(DepositData['total_amount'])) {
                setDepositData({ ...DepositData, [name]: parseInt(value), ['sign_on']: parseInt(eval(DepositData['total_amount'] - value)) });
            }
            else {
                if (value === '') {
                    setDepositData({ ...DepositData, [name]: 0, ['sign_on']: parseInt(DepositData['total_amount']) })
                }
                else {
                    setAlertMessage("Amount should not be greater than total amount")
                    setAlertType("error")
                    handleAlertOpen()
                }

            }
        }
        else {
            if(parseInt(value) <= 100000000|| value===""){
                setDepositData({ ...DepositData, [name]: parseInt(value), ['sign_on']: parseFloat(value/2), ['hardware']: parseFloat(value/2) });
            }
        }
    };


    const handleButtonClick = () => {
        if (PaymentMode === 'bank_deposit') {
            if (DepositData['total_amount'] && DepositData['total_amount'] !== null && DepositData['total_amount']>1) {
                if ((DepositData['sign_on'] && DepositData['sign_on'] !== null) || (DepositData['hardware']) && DepositData['hardware'] !== null) {
                    Nav('/Admin/bankdeposit', {
                        state: DepositData
                    })
                }
                else {
                    setAlertMessage("Sign on payment is required")
                    setAlertType("error")
                    handleAlertOpen()
                }

            }
            else {
                setAlertMessage("Amount cannot be zero. Please enter a valid amount")
                setAlertType("error")
                handleAlertOpen()
            }
        }
        else {
            if (Amount === null||Amount===""||Amount<1) {
                setAlertMessage("Amount cannot be zero. Please enter a valid amount")
                setAlertType("error")
                handleAlertOpen()
            }
            else{
                PostOnlinePayment(
                    {
                    "amount":Amount,
                    "wallet_type":props.category,
                    "transaction_method":props.payment_option},
                    handleOpenLoader,
                    handleCloseLoader,
                    setAlertMessage,
                    setAlertType,
                    handleAlertOpen,
                    props.handleBack
                )
            }
        }

    }

    console.log(Amount);

    return (
        <Grid container justifyContent='space-between' height='100%' mt={1}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={IsLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar anchorOrigin={{ horizontal: 'right', vertical: 'top' }} open={OpenAlert} autoHideDuration={6000} onClose={handleAlertClose}>
                <Alert
                    onClose={handleAlertClose}
                    severity={AlertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {AlertMessage}
                </Alert>
            </Snackbar>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} height='100%'>
                <Stack justifyContent='space-between' height='100%'>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Grid container gap={2}>
                            {/* <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Payment Mode</InputLabel>
                                    <Select
                                        labelid="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={PaymentMode}
                                        label="Payment Mode"
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={'online'}>Online</MenuItem>
                                        <MenuItem value={'bank_deposit'}>Bank Deposit</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            {
                                PaymentMode === 'online' ?
                                    <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                        <TextField
                                            id="outlined-basic"
                                            
                                            label="Amount"
                                            variant="outlined"
                                            value={Amount ? Amount : ''}
                                            onChange={(e) => handleAmountValueChange(e)}
                                            fullWidth
                                        />
                                    </Grid>

                                    :
                                    PaymentMode === 'bank_deposit' ?
                                        <Grid container gap={1}>
                                            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="Total Amount"
                                                    required
                                                    InputLabelProps={{
                                                        sx: {
                                                          '& .MuiInputLabel-asterisk': {
                                                            color: 'red',
                                                          },
                                                        },
                                                      }}
                                                    variant="outlined"
                                                    value={DepositData['total_amount'] ? DepositData['total_amount'] : ''}
                                                    onChange={(e) => handleAmountChange("total_amount", e.target.value)}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid container gap={1}>
                                                <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        label="Sign on"
                                                        
                                                        InputLabelProps={{
                                                            sx: {
                                                              '& .MuiInputLabel-asterisk': {
                                                                color: 'red',
                                                              },
                                                            },
                                                          }}
                                                        value={DepositData['sign_on'] ? DepositData['sign_on'] : ''}
                                                        variant="outlined"
                                                        onChange={(e) => handleAmountChange("sign_on", e.target.value)}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        label="Hardware"
                                                        value={DepositData['hardware'] ? DepositData['hardware'] : ''}
                                                        variant="outlined"
                                                        
                                                        InputLabelProps={{
                                                            sx: {
                                                              '& .MuiInputLabel-asterisk': {
                                                                color: 'red',
                                                              },
                                                            },
                                                          }}
                                                        onChange={(e) => handleAmountChange("hardware", e.target.value)}
                                                        fullWidth
                                                    />
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                        :
                                        null
                            }
                        </Grid>
                    </Grid>
                    <Grid container justifyContent='center'>
                        <Grid mt={5} item xl={3} lg={3} md={4} sm={12} xs={4} >
                            <Button disabled={PaymentMode ? false : true} variant='contained' color='secondary' fullWidth onClick={() => handleButtonClick()}>{PaymentMode==="bank_deposit"?"Proceed":"Make payment"}</Button>
                        </Grid>
                    </Grid>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default AddMoneyTab